import React,{useEffect} from "react";
import { BrowserRouter,useLocation } from "react-router-dom";
import Router from "./Router";
import Header from "./Components/Header";
import axios from "axios";
axios.defaults.withCredentials = true;
function App() {
  const location = window.location.pathname;
  useEffect(() => {
    window.scrollTo(0, 0);
  }, [location]);

 
  return (
      <Router/>
  );
}
export default App;
